export default __webpack_public_path__ + "static/media/WINE4.dd1c86fb.jpg";